export const getClientRequestUrl = async (headers: Headers) => {
  const headersList = headers;
  return (
    headersList.get("x-client-request-url") || headersList.get("referer") || ""
  );
};
